import React from 'react';
import video from './video/hero-video.mp4';
import { Link } from 'react-router-dom';
const Hero = () => {
  return (
    <>
    {/* Hero Start  */}

     <div className="container-fluid pt-5 hero-header mb-5">

     <video autoPlay muted loop preload='auto'>
    <source src={video} loading="lazy" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

      <div className="container pt-5 heroLetterMobile">
        <div className="row g-5 pt-1 mt-5">
          <div className="col-lg-6 align-self-center text-center text-lg-start mb-lg-5 mobileViewHero" >
            <h1 className="display-4 text-white mb-4 animate__animated animate__slideInRight glow-text">
            Expert CyberSecurity Solutions to Safeguard Your Digital Infrastructure</h1>
            <p className="text-white mb-4 animate__animated animate__slideInRight glow-textSmall">
            Comprehensive Protection Against Evolving Digital Threats
            </p>
            <Link to="/contact" className="btn btn-outline-light py-sm-3 px-sm-5 rounded-pill me-3 animate__animated animate__slideInRight">Let’s Protect Your Business Today</Link>
<Link to="/contact" className="btn btn-primary py-sm-3 px-sm-5 rounded-pill animate__animated animate__slideInRight contactBtn">Contact Us</Link>

          </div>
          
          {/* <div className="col-lg-6 align-self-end text-center text-lg-end">
             <img className="img-fluid" src={img} alt="hero" />  
          </div> */}
        </div>
      </div>
    </div>

    {/* Hero End  */}

    {/* search button icon popup */}

    <div className="modal fade" id="searchModal" tabIndex="-1">
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content" style={{ background: 'rgba(20, 24, 62, 0.7)' }}>
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn btn-square bg-white btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body d-flex align-items-center justify-content-center">
            <div className="input-group" style={{ maxWidth: '600px' }}>
              <input
                type="text"
                className="form-control bg-transparent border-light p-3"
                placeholder="Type search keyword"
              />
              <button className="btn btn-light px-4">
                <i className="bi bi-search" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* search button icon popup */}

    </>
  )
}

export default Hero